import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Panel from 'components/Panel';
import { jsx as _jsx } from "react/jsx-runtime";
export function SendButtonPanel(_ref) {
  var isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Panel, {
    align: "center",
    children: /*#__PURE__*/_jsx(Button, {
      type: "submit",
      variant: "primary",
      icon: "send",
      isDisabled: isDisabled,
      children: t('actions_share')
    })
  });
}
export default SendButtonPanel;